<template>
  <div id="make">
    <div id="make-header">
      <div class="left-wrapper">
        <img src="@assets/icon/icon_make.png">
        <span style="margin-left: 16px; font-size: 16px; color: #606266;">内容制作</span>
      </div>
      <div class="right-wrapper">
        <el-popover
          v-if="siteMsg&&siteMsg.h5Template&&siteMsg.webTemplate"
          v-model="visible1"
          placement="bottom"
          popper-class="make-popper"
          trigger="click"
          class="flex"
        >
          <div
            class="option"
            @click="submitForm(2)"
          >
            <img src="@assets/icon/icon_preview.png">预览H5
          </div>
          <div
            class="option"
            @click="submitForm(3)"
          >
            <img src="@assets/icon/icon_preview.png">预览WEB
          </div>
          <template slot="reference">
            <div
              class="operate"
              style="margin-left: 20px;"
            >
              <img src="@assets/icon/icon_preview.png">
              <span style="display: block; font-size: 12px; color: #666;">预览</span>
            </div>
            <div class="icon-more">
              <i
                class="el-icon-caret-bottom"
                style="color: #666;"
              />
            </div>
          </template>
        </el-popover>
        <div
          v-else-if="siteMsg&&siteMsg.h5Template"
          class="operate"
          @click="submitForm(2)"
        >
          <img src="@assets/icon/icon_preview.png">
          <span style="display: block; font-size: 12px; color: #666;">预览</span>
        </div>
        <div
          v-else-if="siteMsg&&siteMsg.webTemplate"
          class="operate"
          @click="submitForm(3)"
        >
          <img src="@assets/icon/icon_preview.png">
          <span style="display: block; font-size: 12px; color: #666;">预览</span>
        </div>
        <el-popover
          v-model="visible"
          placement="bottom"
          popper-class="make-popper"
          trigger="click"
          class="flex"
        >
          <div
            class="option"
            @click="submitForm(0)"
          >
            <img src="@assets/icon/icon_save.png">保存为草稿
          </div>
          <div
            class="option"
            @click="submitForm(1)"
          >
            <img src="@assets/icon/icon_save.png">保存并发布
          </div>
          <template slot="reference">
            <div
              class="operate"
              style="margin-left: 20px;"
            >
              <img src="@assets/icon/icon_save.png">
              <span style="display: block; font-size: 12px; color: #666;">保存</span>
            </div>
            <div class="icon-more">
              <i
                class="el-icon-caret-bottom"
                style="color: #666;"
              />
            </div>
          </template>
        </el-popover>
      </div>
    </div>
    <div
      v-if="contentData"
      class="content-wrapper min-scrollbar"
    >
      <el-form
        ref="ruleForm1"
        :model="contentData"
        :rules="rules"
        label-position="top"
        label-width="100px"
      >
        <el-form-item
          label="标题"
          prop="title"
        >
          <el-input
            v-model.trim="contentData.title"
            :maxlength="30"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item
          label="副标题"
          prop="subtitle"
        >
          <el-input
            v-model="contentData.subtitle"
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 10 }"
            placeholder="请输入副标题"
          />
        </el-form-item>
        <el-form-item
          label="关键字"
          prop="keyWords"
        >
          <div class="keyWord-list">
            <span
              v-for="(text, index) in contentData.keyWords"
              :key="index"
              class="word"
            >
              {{ text }}
              <i
                class="el-icon-close"
                @click="deleteKeyWord(text)"
              />
            </span>
          </div>
          <div class="input-wrapper">
            <el-input
              v-model.trim="temp.keyWord"
              :maxlength="10"
              placeholder="请输入文档关键字"
              @keydown.native.enter="addKeyWord('single')"
            />
            <el-button
              type="text"
              style="margin-left: 15px;"
              @click="addKeyWord('single')"
            >
              添加
            </el-button>
            <el-button
              type="text"
              @click="showKeyWordDialog = true"
            >
              批量添加
            </el-button>
          </div>
        </el-form-item>
        <el-form-item
          label="封面图"
          prop="images"
        >
          <div class="image-list">
            <span
              v-for="(url, index) in contentData.images"
              :key="index"
              class="image-wrapper"
            >
              <img
                :src="url"
                @click="previewDialog=true;previewType='image';previewUrl=url"
              >
              <i
                class="el-icon-error"
                @click="deleteImage(url)"
              />
            </span>
            <yxp-upload
              v-show="contentData.images.length < 6"
              ref="yxpupload"
              uploader-id="uploadId"
              :limit="1"
              :max-size="5120"
              :accept="acceptType"
              :file-list="list"
              upload-url="/res-file/upload/"
              upload-mode-type="resource/wangyeguanli"
              class-name="cover-button"
              btn-name=""
              :show-list="false"
              :auto-upload="true"
              @onChange="onChange"
              @onFail="onFail"
              @onSucc="onSucc"
            />
          </div>
          <div class="tip">
            每张图片大小限制5MB，最多上传6张
          </div>
        </el-form-item>
        <el-form-item
          label="简介"
          prop="remark"
        >
          <el-input
            v-model="contentData.remark"
            type="textarea"
            :maxlength="200"
            :autosize="{ minRows: 5, maxRows: 10 }"
            placeholder="请输入简介"
          />
        </el-form-item>
        <el-form-item
          label="正文"
          prop="contentType"
        >
          <el-radio-group
            v-model="contentData.contentType"
            @change="changeType"
          >
            <el-radio :label="0">
              富文本
            </el-radio>
            <el-radio :label="1">
              链接
            </el-radio>
            <el-radio :label="2">
              视频
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div
        v-if="contentData.contentType === 0"
        class="second-title"
        label="内容"
        style="position: relative; margin-bottom: 10px;"
      >
        <div style="margin-bottom: 22px;">
          <span style="color: #F56C6C; margin-righ ">*</span>内容
        </div>
        <yxp-editor
          ref="editor"
          v-model="contentData.contentText"
          :config="config"
        />
        <div
          v-show="checkText && contentData.contentType === 0 && (!contentData.contentText || contentData.contentText === ' ')"
          class="el-form-item__error"
        >
          请输入正文内容
        </div>
      </div>
      <el-form
        ref="ruleForm2"
        :model="contentData"
        :rules="rules"
        label-position="top"
        label-width="100px"
      >
        <el-form-item
          v-if="contentData.contentType === 1"
          class="second-title"
          label="链接"
          prop="contentLink"
        >
          <el-input
            v-model.trim="contentData.contentLink"
            placeholder="请输入跳转的链接地址"
          />
        </el-form-item>
        <el-form-item
          v-if="contentData.contentType === 2"
          class="second-title"
          label="视频"
          prop="contentVideo"
        >
          <div class="media-wrapper">
            <div class="video-wrapper">
              <div class="upload-title">
                上传视频
              </div>
              <span
                v-if="contentData.contentVideo"
                class="image-wrapper"
                @click="previewDialog = true;previewType='video'"
              >
                <i
                  class="el-icon-error"
                  @click.stop="deleteVedioInfo('contentVideo')"
                />
              </span>
              <span
                v-if="temp.loading"
                class="loading-wrapper"
              >上传中</span>
              <yxp-upload
                v-show="!contentData.contentVideo && !temp.loading"
                ref="yxpupload"
                uploader-id="uploadId"
                :limit="1"
                :max-size="512000"
                :accept="acceptVideoType"
                :file-list="videoList"
                upload-url="/res-file/upload/"
                upload-mode-type="resource/wangyeguanli"
                class-name="cover-button"
                btn-name=""
                :show-list="true"
                :auto-upload="true"
                @onProgress="onProgress"
                @onChange="onVideoChange"
                @onFail="onVideoFail"
                @onSucc="onVideoSucc"
              />
              <div class="video-name">
                {{ contentData.contentVideoName }}
              </div>
            </div>
            <div class="cover-wrapper">
              <div class="upload-title">
                上传视频封面图
              </div>
              <span
                v-if="contentData.contentVideoImage"
                class="image-wrapper"
              >
                <img
                  :src="contentData.contentVideoImage"
                  @click="previewDialog=true;previewType='image';previewUrl=contentData.contentVideoImage"
                >
                <i
                  class="el-icon-error"
                  @click.stop="deleteVedioInfo('contentVideoImage')"
                />
              </span>
              <yxp-upload
                v-show="!contentData.contentVideoImage"
                ref="yxpupload"
                uploader-id="uploadId"
                :limit="1"
                :max-size="5120"
                :accept="acceptType"
                :file-list="list"
                upload-url="/res-file/upload/"
                upload-mode-type="resource/wangyeguanli"
                class-name="cover-button"
                btn-name=""
                :show-list="false"
                :auto-upload="true"
                @onChange="onChange"
                @onFail="onFail"
                @onSucc="onCoverSucc"
              />
            </div>
          </div>
        </el-form-item>
        <div class="el-form-item__label">
          来源
        </div>
        <el-form-item
          label="来源名称"
          class="second-title"
          prop="sourceName"
        >
          <el-input
            v-model="contentData.sourceName"
            :maxlength="30"
            placeholder="请输入来源名称"
          />
        </el-form-item>
        <el-form-item
          label="来源链接"
          class="second-title"
          prop="sourceLink"
        >
          <el-input
            v-model.trim="contentData.sourceLink"
            placeholder="请输入来源链接"
          />
        </el-form-item>
      </el-form>
    </div>
    <!-- </el-scrollbar> -->
    <div
      v-if="contentData"
      class="prop-info min-scrollbar"
    >
      <div class="prop-title">
        属性信息
      </div>
      <div class="item">
        <div class="item-title">
          <span class="label">内容标签：</span>
          <a
            href="javascript:;"
            class="text-button"
            @click="showTagVisible"
          >
            标签管理
          </a>
        </div>
        <div
          class="tag-list"
          style="cursor: pointer;"
          @click="showActiveDialog = true"
        >
          <span
            v-for="(tag, index) in activeTagLists"
            :key="index"
            class="tag"
          >
            {{ tag.name }}
            <i
              class="el-icon-close"
              @click.stop="deleteTag(tag.id)"
            />
          </span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          <span class="label">内容角标：</span>
        </div>
        <div class="mark">
          <yxp-upload
            v-if="!contentData.contentCornerMarker"
            ref="yxpupload"
            uploader-id="uploadId"
            :limit="1"
            :max-size="500"
            :accept="acceptType"
            :file-list="list"
            upload-url="/res-file/upload/"
            upload-mode-type="resource/wangyeguanli"
            btn-name=""
            class-name="cover-button"
            :show-list="false"
            :auto-upload="true"
            @onChange="onChange"
            @onFail="onFail"
            @onSucc="onMarkSucc"
          />
          <template v-else>
            <i
              class="el-icon-error"
              @click="contentData.contentCornerMarker = null"
            />
            <img
              :src="contentData.contentCornerMarker"
              @click="previewDialog=true;previewType='image';previewUrl=contentData.contentCornerMarker"
            >
          </template>
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          <span class="label required">所属栏目：</span>
        </div>
        <div
          class="node-list"
          @click="showTreeDialog = true"
        >
          <span
            v-for="(node, index) in nodeList"
            :key="index"
            class="node"
          ><span
            v-if="index > 0"
            class="symbol"
          > > </span>{{ node.name }}</span>
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          <span class="">页面边距：</span>
        </div>
        <div style="margin-top:10px">
          <el-radio
            v-model="radio"
            label="1"
          >
            有边距
          </el-radio>
          <el-radio
            v-model="radio"
            label="0"
          >
            无边距
          </el-radio>
        </div>
      </div>
      <div class="item">
        <div class="item-title">
          <span class="label">排序：</span>
        </div>
        <el-select
          v-model="contentData.rank"
          popper-class="make-select-drapdown"
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in 99"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </div>
    </div>
    <el-dialog
      :visible.sync="showKeyWordDialog"
      width="400px"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>批量添加关键字</span>
      </div>
      <div>
        <el-input
          v-model="temp.mutiKeyWord"
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10 }"
          placeholder="请输入关键字，多个关键字断行处理"
        />
      </div>
      <div class="dialog-footer">
        <el-button @click="showKeyWordDialog = false">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="addMutiWord"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-if="previewDialog"
      :visible.sync="previewDialog"
      width="50%"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>{{ previewType === 'video' ? '播放视频' : '预览图片' }}</span>
      </div>
      <video
        v-if="previewType === 'video'"
        style="width: 100%;"
        controls
        autoplay
      >
        <source
          :src="contentData.contentVideo"
          type="video/mp4"
        >
      </video>
      <div
        v-else
        style="text-align: center; display: flex; justify-content: center; align-items: center; min-height: 300px;"
      >
        <img
          :src="previewUrl"
          style="max-width: 100%; max-height: 600px;"
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showTagDialog"
      width="500px"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>添加内容标签</span>
      </div>
      <div class="flex">
        <el-input
          v-model="temp.tag"
          :maxlength="10"
          placeholder="请输入内容标签"
        />
        <el-button
          type="primary"
          style="margin-left: 20px;"
          @click="addTag"
        >
          添加
        </el-button>
      </div>

      <div class="tag-list">
        <span
          v-for="(tag, index) in contentData.tagList"
          :key="index"
          class="tag"
        >
          {{ tag.name }}
          <i
            class="el-icon-close"
            @click="delTag(tag)"
          />
        </span>
      </div>
      <!-- <div class="dialog-footer">
        <el-button @click="showTagDialog = false">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="confirm"
        >
          确定
        </el-button>
      </div> -->
    </el-dialog>
    <el-dialog
      :visible.sync="showTreeDialog"
      width="500px"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>所属栏目</span>
      </div>
      <div
        class="min-scrollbar"
        style="max-height: 400px; overflow-y: auto; border: 1px solid #DCDFE6;"
      >
        <el-tree
          class="column-tree"
          :data="treeList"
          node-key="catalogId"
          :props="defaultProps"
          :highlight-current="true"
          :check-on-click-node="true"
          :default-expanded-keys="defaultExpandedKeys"
          @node-click="handleNodeClick"
        />
      </div>
      <div class="dialog-footer">
        <el-button @click="showTreeDialog = false">
          取消
        </el-button>
        <el-button
          type="primary"
          @click="selectColumn"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="showActiveDialog"
      width="500px"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>添加内容标签</span>
      </div>

      <el-checkbox-group
        v-model="activeTagList"
        @change="changeTage"
      >
        <span
          v-for="(tag, index) in temp.tagList"
          :key="index"
          class="checkbox_item"
        >
          <el-checkbox :label="tag.id">
            <span class="tagItemName">
              {{ tag.name }}
            </span>
          </el-checkbox>
        </span>
      </el-checkbox-group>
    </el-dialog>
  </div>
</template>

<script>
import api from './proxy';
import UploadImg from '../../../common/tools/UploadImg';

export default {
    name: 'Make',
    components: { UploadImg },
    data () {
        var checkLink = (rule, value, callback) => {
            // if (!value) return callback(new Error('栏目链接不能为空'));
            let strRegex = '^((https|http|ftp|rtsp|mms)?://)' +
                "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + // ftp的user@
                '(([0-9]{1,3}\.){3}[0-9]{1,3}' + // IP形式的URL- 199.194.52.184
                '|' + // 允许IP和DOMAIN（域名）
                "([0-9a-z_!~*'()-]+\.)*" + // 域名- www.
                '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\.' + // 二级域名
                '[a-z]{2,6})' + // first level domain- .com or .museum
                '(:[0-9]{1,4})?' + // 端口- :80
                // '((/?)|' + // a slash isn't required if there is no file name
                // "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
                '';
            let re = new RegExp(strRegex);
            if (re.test(value)) {
                callback();
            } else {
                return callback(new Error('链接不合法，请重新输入'));
            }
        };
        var checkValue = (rule, value, callback) => {
            if (!value) return callback(new Error('链接不能为空'));
            checkLink(rule, value, callback);
        };
        var checkValue2 = (rule, value, callback) => {
            if (!value) return callback();
            checkLink(rule, value, callback);
        };
        return {
            checkText: false, // 是否校验富文本
            catalogId: Number(this.$route.query.catalogId),
            nodeList: [], // 选择栏目从顶层到选中层级的节点列表
            contentData: '',
            treeList: [],
            defaultExpandedKeys: [],
            treeMutationList: [],
            temp: {
                keyWord: '',
                mutiKeyWord: '',
                tag: '',
                tagList: [],
                loading: false,
            },
            showKeyWordDialog: false,
            previewDialog: false,
            previewType: 'video',
            previewUrl: null,
            showTagDialog: false,
            showTreeDialog: false,
            visible1: false,
            visible: false,
            acceptType: '.jpg,.jpeg,.png',
            list: [],
            acceptVideoType: '.mp4',
            videoList: [],
            defaultProps: {
                children: 'children',
                label: 'name',
            },
            uploadOption: {
                title: '上传视频', // 模态框标题
                uploadType: 'video', // 视频：video，音频：audio，图片：img，其他：other
                tips: '支持格式：mp4，大小：500MB以内', // 说明文字
                size: 500, // 限制大小（单位M）
                ctrlType: 'upload', // 操作类型: upload上传，modify修改,clone克隆修改
                useScene: '1', // 使用场景 1.我的资源-我的视频  2.教育资源管理（默认为-我的资源）
            },
            listLimit: {
                keywords: '', // 关键字, 视频名称/ID/上传者ID
                relationType: '', // 与教材/教辅/专题/知识点的关系：1. 教材 2.教辅 3.专题 4.知识点
                relationItemId: '', // 教材/教辅/专题/知识体系ID
                chapterIds: '', // 教材章节/教辅章节/专题章节/知识点ID  逗号隔开
                useScene: '1', // 使用场景 1.我的资源-我的视频  2.教育资源管理
                // queryOrgId: '', // 我的资源中查询时，下拉框传入的orgId
            },
            selectNode: null,
            isScroll: false,
            element: null,
            observer: null,
            timer: -1,
            siteMsg: {},
            recordOldValue: { // 记录下旧的宽高数据，避免重复触发回调函数
                width: '0',
                height: '0',
            },
            rules: {
                title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                contentLink: [{ required: true, validator: checkValue, trigger: 'blur' }],
                sourceLink: [{ validator: checkValue2, trigger: 'blur' }],
                contentVideo: [{ required: true, message: '请上传视频', trigger: 'change' }],
            },
            config: {
                image: { // 上传图片的地址
                    uploadUrl: '/res-file/upload',
                    uploadModeType: '/resource/wangyeguanli',
                },
                audio: { // 上传音频的地址
                    uploadUrl: '/res-file/upload',
                    uploadModeType: '/resource/wangyeguanli',
                },
                video: { // 上传视频的地址
                    uploadUrl: '/res-file/upload',
                    uploadModeType: '/resource/wangyeguanli',
                },
            },
            activeTagList: [],
            activeTagLists: [],
            radio: '1',
            tagList: [],
            showActiveDialog: false,
        };
    },
    computed: {
        cpUserId () {
            return this.$store.state.global.loginInfo.userId;
        },
        siteId () {
            return this.$route.query.siteId || (this.$store.getters['system/getSiteList'].length > 0 ? this.$store.getters['system/getSiteList'][0].siteId : null);
        },
    },
    watch: {
        'contentData.contentText' () {
            this.checkText = true;
        },
    },
    created () {
        this.init();
        setTimeout(() => {
            let isnew = this.$route.query.isnew;
            console.log(isnew);
            if (isnew) {
                this.contentData.rank = this.$route.query.sort;
            }
        }, 200);
        this.siteMsg = JSON.parse(sessionStorage.getItem('websiteMsg'));
    },
    mounted () {
        this.$nextTick(() => {
            this.handleResize();
        });
    },
    beforeDestroyed () {
        if (this.observer) {
            this.observer.disconnect();
            this.observer.takeRecords();
            this.observer = null;
        }
    },
    methods: {
        init () {
            if (this.$route.query.contentId) {
                this.getInfo();
            } else {
                this.contentData = {
                    contentId: null,
                    catalogId: 0,
                    title: '',
                    subtitle: '',
                    keyWords: [],
                    images: [],
                    remark: '',
                    contentType: 0,
                    contentText: '',
                    contentLink: '',
                    contentVideo: '',
                    contentVideoName: '',
                    contentVideoImage: '',
                    contentCornerMarker: '',
                    sourceName: '',
                    sourceLink: '',
                    tagList: [],
                    rank: 1,
                };
                this.getTreeList();
                this.getTagList();
                this.getTagListBySiteId();
                setTimeout(() => {
                    this.checkText = false;
                }, 0);
            }
        },
        // 获取已经选中的标签
        getTagList () {
            api.getTagList({ siteId: this.siteId, contentId: this.$route.query.contentId }).then(res => {
                if (res.errcode === 0) {
                    let tagList = res.data;

                    tagList.forEach(e => {
                        // 用于复选框
                        this.activeTagList.push(e.id);
                        // 用于显示
                        this.activeTagLists.push(e);
                    });
                    // this.temp.tagList = res.data;
                    // console.log(res);
                }
            });
        },
        // 获取全部的标签
        getTagListBySiteId () {
            api.getTagListBySiteId({ siteId: this.siteId }).then(res => {
                if (res.errcode === 0) {
                    this.contentData.tagList = res.data;
                    this.temp.tagList = res.data;
                    // this.temp.tagList = res.data;
                }
            });
        },
        changeTage (e) {
            console.log(e);
            this.activeTagLists = [];
            this.temp.tagList.forEach(item => {
                e.forEach(tag => {
                    if (tag === item.id) {
                        this.activeTagLists.push(item);
                    }
                });
            });
        },
        // 添加标签
        requestAddTag (tag) {
            let data = {
                siteId: this.siteId,
                tagNames: tag,
            };
            api.addTag(data).then((res) => {
                if (res.errcode === 0) {
                    this.getTagListBySiteId();
                }
            });
        },
        // 删除添加标签
        delTag (tag) {
            let data = {
                siteId: this.siteId,
                tagIds: [tag.id],
            };
            api.delTag(data).then((res) => {
                if (res.errcode === 0) {
                    this.getTagListBySiteId();
                }
            });
        },
        getInfo () {
            api.getInfo({ contentId: this.$route.query.contentId }).then(res => {
                if (res.errcode === 0) {
                    res.data.tagList = [];
                    this.catalogId = res.data.catalogId;
                    this.contentData = res.data;
                    this.radio = String(this.contentData.marginStatus);
                    setTimeout(() => {
                        this.checkText = false;
                    }, 0);
                    this.$nextTick(() => {
                        this.observerHandler();
                        this.handleResize();
                    });
                    this.getTagList();
                    this.getTreeList();
                    this.getTagListBySiteId();
                }
            });
        },
        getTreeList () {
            api.getTreeList({ siteId: this.siteId, isShowDisable: 0 }).then(res => {
                if (res.errcode === 0) {
                    const all = {
                        catalogId: 0,
                        name: '站点栏目',
                        pCatalogId: null,
                        type: '0',
                        image: '',
                        describe: '',
                        catalogLink: '',
                        rank: 0,
                        status: 0,
                        children: [],
                    };
                    all.children = res.data.value.catalogList;
                    this.defaultExpandedKeys = [0];
                    res.data.value.catalogList.forEach(item => {
                        this.defaultExpandedKeys.push(item.catalogId);
                        if (item.children.length > 0) {
                            item.children.forEach(it => {
                                this.defaultExpandedKeys.push(item.catalogId);
                            });
                        }
                    });
                    this.treeList = [all];
                    this.treeMutationList = this.getList(this.treeList);
                    this.getNodeList(this.catalogId);
                }
            });
        },
        getList (list, result = []) {
            if (list.length > 0) {
                list.forEach(item => {
                    result.push(item);
                    if (item.children.length > 0) this.getList(item.children, result);
                });
            }
            return result;
        },
        handleNodeClick (node) {
            this.selectNode = node;
        },
        selectColumn () {
            if (!this.selectNode) return;
            // if (this.selectNode.children.length === 0) {
            this.nodeList = [];
            this.contentData.catalogId = this.selectNode.catalogId;
            this.getNodeList(this.selectNode.catalogId);
            this.showTreeDialog = false;
            // } else {
            //     this.$message.warning('请选择叶子节点');
            // }
        },
        // 获取所有上级节点
        getNodeList (catalogId) {
            let node = this.treeMutationList.find(node => node.catalogId === catalogId);
            if (node) {
                this.nodeList.unshift(node);
                // console.log(this.nodeList);
                if (node.pCatalogId !== null) this.getNodeList(node.pCatalogId);
                if (this.nodeList.length) {
                    this.contentData.catalogId = this.nodeList[this.nodeList.length - 1].catalogId;
                }
            }
        },
        changeType (value) {
            switch (value) {
                case 0:
                    this.checkText = false;
                // eslint-disable-next-line no-fallthrough
                case 1:
                    return this.$refs.ruleForm2.clearValidate('contentLink');
                case 2:
                    return this.$refs.ruleForm2.clearValidate('contentVideo');
            }
        },
        addKeyWord (type, keyWord = this.temp.keyWord) {
            if (keyWord) {
                if (this.contentData.keyWords.includes(keyWord)) {
                    if (type === 'single') this.$message.warning('该关键字已存在');
                } else {
                    this.contentData.keyWords.push(keyWord);
                    if (type === 'single') this.temp.keyWord = '';
                }
            }
        },
        showTagVisible () {
            this.showTagDialog = true;
            this.temp.tag = '';
            // this.temp.tagList = [...this.contentData.tagList];
        },
        addTag () {
            if (this.temp.tag) {
                if (!this.temp.tagList.includes(this.temp.tag)) {
                    this.requestAddTag([this.temp.tag]);
                    // this.temp.tagList.push(this.temp.tag);
                    this.temp.tag = '';
                }
            }
        },
        // confirm () {
        //     this.saveTag([...this.temp.tagList]);
        //     // this.contentData.tagList = [...this.temp.tagList];
        //     this.showTagDialog = false;
        // },
        addMutiWord () {
            let list = this.temp.mutiKeyWord.split('\n').map(text => text.length > 10 ? text.substring(0, 10) : text);
            list.forEach(text => this.addKeyWord('muti', text));
            this.showKeyWordDialog = false;
            this.temp.mutiKeyWord = '';
        },
        deleteKeyWord (text) {
            let index = this.contentData.keyWords.indexOf(text);
            if (index > -1) this.contentData.keyWords.splice(index, 1);
        },
        // deleteTag (text) {
        //     let index = this.contentData.tagList.indexOf(text);
        //     if (index > -1) this.contentData.tagList.splice(index, 1);
        // },
        deleteTag (id) {
            let index = this.activeTagLists.findIndex(tag => {
                return tag.id === id;
            });
            this.activeTagLists.splice(index, 1);
            this.activeTagList.splice(this.activeTagList.indexOf(id), 1);
        },
        deleteTempTag (text) {
            let index = this.temp.tagList.indexOf(text);
            if (index > -1) this.temp.tagList.splice(index, 1);
        },
        onSucc (res, file) {
            this.contentData.images.push(res.url);
            this.list = [];
        },
        onChange (file) {},
        onFail (file) {
            this.$message.warning(file.errMsg);
        },
        onVideoSucc (res, file) {
            this.contentData.contentVideoName = res.result.fileOriginalName;
            this.temp.loading = false;
            this.contentData.contentVideo = res.url;
            this.videoList = [];
        },
        onVideoChange (file) {
            this.temp.loading = true;
        },
        onProgress (progress) {
        },
        onVideoFail (file) {
            this.temp.loading = false;
            this.$message.warning(file.errMsg);
        },
        onCoverSucc (res, file) {
            this.contentData.contentVideoImage = res.url;
            this.list = [];
        },
        onMarkSucc (res, file) {
            this.contentData.contentCornerMarker = res.url;
            this.list = [];
        },
        uploadSuccess (p) {
            this.contentData.contentCornerMarker = p.fileUrl;
        },
        deleteImage (url) {
            let index = this.contentData.images.indexOf(url);
            if (index > -1) this.contentData.images.splice(index, 1);
        },
        deleteVedioInfo (prop) {
            if (prop === 'contentVideo') this.contentData.contentVideoName = null;
            this.contentData[prop] = '';
        },
        submitForm (submitStatus) {
            if (this.temp.loading) return;
            this.checkText = true;
            this.$refs.ruleForm1.validate((valid1) => {
                this.$refs.ruleForm2.validate((valid2) => {
                    let valid3 = this.contentData.contentType !== 0 || (!!this.contentData.contentText && this.contentData.contentText !== ' ');
                    if (valid1 && valid2 && valid3) {
                        this.temp.loading = true;
                        let data = JSON.parse(JSON.stringify(this.contentData));
                        // data.delite;
                        delete data.tagList;
                        data.tagList = this.activeTagList;
                        console.log(this.radio);
                        if (submitStatus === 2) {
                            api.previewSave({ ...data, submitStatus, marginStatus: Number(this.radio), siteId: this.siteId }).then(res => {
                                if (res.errcode === 0) {
                                    sessionStorage.setItem('contentData', JSON.stringify(this.contentData));
                                    let url = this.$router.resolve({ name: 'mobileBoxContent', query: { contentId: res.data.contentId, type: 1 } });
                                    window.open(url.href, '_blank');
                                } else {
                                    this.$message.warning(res.errmsg);
                                }
                            }).finally(() => {
                                this.temp.loading = false;
                            });
                        } else if (submitStatus === 3) {
                            api.previewSave({ ...data, submitStatus: 2, marginStatus: Number(this.radio), siteId: this.siteId }).then(res => {
                                if (res.errcode === 0) {
                                    sessionStorage.setItem('contentData', JSON.stringify(this.contentData));
                                    let url = this.$router.resolve({ name: 'webModulePage', query: { contentId: res.data.contentId, type: 1, noLogin: true } });
                                    window.open(url.href, '_blank');
                                } else {
                                    this.$message.warning(res.errmsg);
                                }
                            }).finally(() => {
                                this.temp.loading = false;
                            });
                        } else {
                            api.make({ ...data, submitStatus, marginStatus: Number(this.radio), siteId: this.siteId }).then(res => {
                                if (res.errcode === 0) {
                                    localStorage.setItem('saveUpdate', '1');
                                    window.close();
                                } else {
                                    this.$message.warning(res.errmsg);
                                }
                            }).finally(() => {
                                this.temp.loading = false;
                            });
                        }
                    } else {
                        this.$message.warning('请完善必填项');
                    }
                });
            });
        },
        observerHandler () {
            let MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
            let element = document.querySelector('.w-e-text');
            this.observer = new MutationObserver((mutationList) => {
                let height = getComputedStyle(element).getPropertyValue('height');
                if (height === this.recordOldValue.height) return;
                this.recordOldValue = { height };
                this.debounce(() => this.hasScrollbar(parseInt(height)), 1000)();
            });
            this.observer.observe(element, { attributes: true, attributeFilter: ['style'], attributeOldValue: true });
        },
        handleResize () {
            let editor;
            if (this.element) {
                editor = this.element;
            } else {
                editor = this.element = document.querySelector('.w-e-text-container');
            }
            // editor.onresize = () => {
            //     console.log('resize');
            // };
        },
        debounce (fn, delay) {
            var _this = this;
            return function () {
                clearTimeout(_this.timer);
                _this.timer = setTimeout(() => {
                    fn.apply(_this);
                    _this.timer = null;
                }, delay);
            };
        },
        hasScrollbar () {
            console.log('触发==================');
            let editor;
            if (this.element) {
                editor = this.element;
            } else {
                editor = this.element = document.querySelector('.w-e-text-container');
            }
            this.isScroll = editor.scrollHeight > (editor.innerHeight || editor.clientHeight);
        },
    },
};
</script>
<style lang="scss">

.min-scrollbar {
    &:hover {
        &::-webkit-scrollbar-thumb {
            opacity: 0;
        }
    }
    &::-webkit-scrollbar {
        width: 7px;
        height: 7px;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-button {
        display: none;
    }
    &::-webkit-scrollbar-thumb {
        opacity: 0;
        border-radius: 4px;
        background-color: #E0E3EA;
    }
}
#make {
    margin: 20px auto;
    padding: 0 0 20px 20px;
    width: 1200px;
    display: flex;
    height: calc(100vh - 66px);
    background: #FFF;
    border: 1px solid #F1F1F1;
    .flex {

        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    textarea {
        @extend .min-scrollbar;
        resize: none;
    }
    #make-header {
        @extend .flex;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 56px;
        background: #FFF;
        box-shadow: 0px 4px 2px 0px rgba(0,0,0,0.06);
        z-index: 3000;
        img {
            width: 20px;
            height: 20px;
        }
        .left-wrapper {
            @extend .flex;
            img {
                margin-left: 45px;
            }
        }
        .right-wrapper {
            @extend .flex;
            padding-right: 18px;
            text-align: center;
            .operate {
                cursor: pointer;
            }
            .icon-more {
                margin-top: -15px;
                margin-left: 5px;
                cursor: pointer;
            }
        }
    }
    .content-wrapper {
        flex-grow: 1;
        padding-top: 10px;
        padding-right: 20px;
        height: 100%;
        overflow-y: auto;
        .keyWord-list {
            .word {
                margin-bottom: 10px;
                margin-right: 10px;
                padding: 0 16px;
                display: inline-block;
                line-height: 24px;
                background: #F1FFFA;
                border-radius: 4px;
                color: #999;
                i {
                    cursor: pointer;
                }
            }
        }
        .input-wrapper {
            display: flex;
            .el-button {
                color: #2693F1;
                text-decoration: underline;
            }
        }
        .image-list {
            .image-wrapper {
                position: relative;
                margin-right: 15px;
                margin-bottom: 15px;
                display: inline-block;
                vertical-align: top;
                img {
                    max-width: 300px;
                    height: 80px;
                    border-radius: 4px;
                    cursor: pointer;
                }
                i {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    z-index: 1;
                    font-size: 18px;
                    color: #999;
                    cursor: pointer;
                }
            }
        }
        .yxp-uploader {
            display: inline-block;
            .cover-button {
                width: 124px;
                height: 80px;
                border-radius: 4px;
                background: url('../../../../assets/icon/icon_plus.png') no-repeat center;
                background-color: #F2F4FC;
                background-size: 20px 20px;
                &:hover {
                    background-color: #F2EEFC;
                }
            }
        }
        .media-wrapper {
            display: flex;
            .video-wrapper {
                width: 200px;
            }
            .upload-title {
                color: #505050;
            }
            .image-wrapper {
                position: relative;
                vertical-align: top;
                display: inline-block;
                width: 124px;
                height: 80px;
                border-radius: 4px;
                background: url('../../../../assets/icon/icon_play.png') no-repeat center;
                background-color: #F2F4FC;
                background-size: 20px 20px;
                cursor: pointer;
                i {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    z-index: 1;
                    font-size: 18px;
                    color: #999;
                    cursor: pointer;
                }
            }
            .loading-wrapper {
                position: relative;
                vertical-align: top;
                display: inline-block;
                width: 124px;
                height: 80px;
                line-height: 80px;
                text-align: center;
                border-radius: 4px;
                background-color: #F2F4FC;
                color: #A0A0A0;
                cursor: progress;
            }
            .cover-wrapper {
                .image-wrapper {
                    width: 124px;
                }
                img {
                    max-width: 124px;
                    height: 80px;
                    border-radius: 4px;
                    cursor: pointer;
                }
            }
        }
        .tip {
            color: #F3864B;
        }
        .video-name {
            color: #A0A0A0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        .el-form {
            .el-form-item__label {
                color: #333;
                font-weight: 700;
            }
            .second-title {
                .el-form-item__label {
                    font-weight: 400;
                }
            }
        }
    }
    .prop-info {
        flex-grow: 0;
        flex-shrink: 0;
        width: 320px;
        padding-top: 10px;
        height: 100%;
        overflow-y: auto;
        border: 1px solid #F1F1F1;
        .prop-title {
            padding: 8px 18px 18px;
            line-height: 20px;
            color: #505050;
            font-weight: 700;
            border-bottom: 1px solid #F1F1F1;
        }
        .item {
            padding: 18px 18px 0;
            .item-title {
                display: flex;
                justify-content: space-between;
                .required {
                    display: block;
                    &::before {
                        content: '*';
                        color: #F56C6C;
                        margin-right: 4px;
                    }
                }
            }
            .yxp-uploader {
                display: inline-block;
                .cover-button {
                    width: 124px;
                    height: 80px;
                    border-radius: 4px;
                    background: url('../../../../assets/icon/icon_plus.png') no-repeat center;
                    background-color: #F2F4FC;
                    background-size: 20px 20px;
                    &:hover {
                        background-color: #F2EEFC;
                    }
                }
            }
            .mark {
                position: relative;
                margin-top: 15px;
                margin-right: 15px;
                display: inline-block;
                vertical-align: top;
                width: 124px;
                height: 80px;
                background: #F2F4FC;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                    max-width: 100%;
                    max-height: 100%;
                    border-radius: 4px;
                    cursor: pointer;
                }
                i {
                    position: absolute;
                    top: -8px;
                    right: -8px;
                    z-index: 1;
                    font-size: 18px;
                    color: #999;
                    cursor: pointer;
                }
            }
            .el-select {
                margin-top: 10px;
                width: 100%;
                .el-input {
                    width: 100%;
                }
            }
        }
    }
    .el-dialog {
        .tag-list {
            padding: 20px 0;
            border: none;
            .tag {
                margin-top: 5px;
                margin-right: 10px;
            }
        }
        .dialog-footer {
            margin-top: 15px;
            line-height: 50px;
            text-align: right;
            .el-button {
                margin-left: 15px;
                width: 80px;
            }
        }
    }
    .tag-list {
        padding: 10px;
        margin-top: 5px;
        min-height: 34px;
        border: 1px solid #DEE2E9;
        border-radius: 4px;
        .tag {
            margin: 5px;
            display: inline-block;
            line-height: 24px;
            color: #999;
            background: #F1FFFA;
            border-radius: 4px;
            i {
                color: #999;
                cursor: pointer;
            }
        }
    }
    .node-list {
        margin-top: 10px;
        padding: 5px 10px;
        min-height: 34px;
        border: 1px solid #DEE2E9;
        border-radius: 4px;
        cursor: pointer;
        .node {
            line-height: 24px;
            color: #999;
            .symbol {
                color: #ACACAC;
            }
        }
    }
    .yxp-editor {
        .yd-menus {
            border-radius: 4px 4px 0 0;
        }
        .w-e-text-container {
            min-height: 200px;
            resize: vertical;
            border-radius: 0 0 4px 4px;
        }
        .w-e-text {
            @extend .min-scrollbar;
            overflow-y: scroll;
        }
    }
}
.checkbox_item{
  display:inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
  width: 143px;
  .tagItemName{
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space:nowrap;
    width:115px;
    display:block;
  }

}

.make-popper {
    z-index: 3001 !important;
    .operate {
        font-size: 12px;
        cursor: pointer;
    }
    .icon-more {
        margin-top: -15px;
        margin-left: 5px;
        cursor: pointer;
    }
    img {
        margin-right: 10px;
        width: 20px;
        height: 20px;
        vertical-align: middle;
    }
    .option {
        padding-left: 15px;
        line-height: 36px;
        cursor: pointer;
        &:hover {
            background: #E2E9F0;
        }
    }
}
.make-select-drapdown {
    width: 264px !important;
    min-width: 264px !important;
    .el-select-dropdown__item {
        width: 260px;
    }
}
.text-button{
  color: #2693F1;
  text-decoration: underline;
}
</style>
<style lang='scss' scoped>

.checkbox_item /deep/ .el-checkbox{
    display: flex;
    align-items: center;
  }
</style>
